
export default function Footer() {
  return (
    <footer className="bg-black/30 backdrop-blur-sm border-t border-white/10 py-12 px-6">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <a href="#services" className="flex items-center mb-4 cursor-pointer w-fit">
              <img 
                src="https://static.readdy.ai/image/69020b62159dbcbb93ae23ea16bf9033/6fe36d98a62a7278966c853003907f00.png" 
                alt="AVNEX" 
                className="w-12 h-12 mr-3"
              />
              <span className="text-2xl font-bold text-white">AVNEX</span>
            </a>
            <p className="text-gray-400 leading-relaxed max-w-md">
              Agencia de marketing digital especializada en transformar negocios a través de estrategias innovadoras y resultados medibles.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li><a href="#pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Planes</a></li>
              <li><a href="#portfolio" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Portafolio</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contacto</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">Diseño Web</li>
              <li className="text-gray-400">Redes Sociales</li>
              <li className="text-gray-400">Meta Ads</li>
              <li className="text-gray-400">Automatización</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2024 AVNEX. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
